import axios from "axios";
import { getItem } from '../util/localStorage'
import { apiUrl } from "../config/config";


export const aiService = {
  login,
  Dashboard,
  ChangeStatus,
  leads,
  makeCall,
  save_availibility,
  get_availibility,
  callList,
  changePassword,
  appointments,
  updateappointments,
  dashboard,
  callListGpt,
  makeGptCall,
  signUpUser,
  updateUserDetails,
  userList,
  getUserInfo,
  getUserSubscriptions,
  addUserSubscription,
  cancelActiveSubscription,
  deleteUser,
  configuration,
  listKnowledgeBase,
  addKnowledgeBase,
  deleteKnowledgeBase,
  createAgent,
  getAgents,
  getAgent,
  updateTokenLimit,
  getTokenLimit,
  changeAgentStatus,
  deleteAgent,
  restoreAgent,
  getAvailableNumbers,
  assignNumber,
  deleteNumber,
  getUsageSummary
}



const headers = () => {
  let token = getItem("safe_tek_admin_token")
  return { headers: { 'Authorization': `${token}` } }
};

async function login(data) {
  return await axios.post(`${apiUrl}/super_adminlogin/`, data);
}


async function Dashboard() {
  return await axios.get(`${apiUrl}/admin_dashboard`, headers())
}
async function ChangeStatus(id, params) {
  return await axios.post(`${apiUrl}/change_user_status/${id}/`, params, headers())
}

async function makeCall(params) {
  return await axios.post(`${apiUrl}/outgoing-call`, params, headers())
}

async function save_availibility(params, id) {
  return await axios.post(`${apiUrl}/edit_availability/${id}/`, params, headers())
}
async function get_availibility() {
  return await axios.get(`${apiUrl}/availability_listing/`, headers())
}
async function callList(id) {
  return await axios.get(`${apiUrl}/call-list?lead_id=${id}`, headers())

}
async function appointments(page, page_size, search) {
  return await axios.get(`${apiUrl}/appointments?page=${page}&page_size=${page_size}&date=${search}`, headers())

}
async function updateappointments(data) {
  return await axios.post(`${apiUrl}/appointments`, data, headers())

}

async function changePassword(data) {
  return await axios.post(`${apiUrl}/change_password/`, data, headers())
}

async function dashboard() {
  return await axios.get(`${apiUrl}/list_counts`, headers())
}

async function leads(params) {
  return await axios.get(`${apiUrl}/contactus_listing?limit=${params.limit}&page=${params.page}&search_query=${encodeURIComponent(params.search || "")}`, headers())
}

async function callListGpt(params) {
  return await axios.get(`${apiUrl}/call-list-gpt/?limit=${params.limit}&page=${params.page}`, headers())
}

async function makeGptCall(params) {
  return await axios.post(`${apiUrl}/outgoing/`, params, headers())
}

async function signUpUser(params) {
  return await axios.post(`${apiUrl}/signup/`, params, headers())
}

async function updateUserDetails(id, params) {
  return await axios.patch(`${apiUrl}/users/${id}/details/`, params, headers())
}

async function getUserSubscriptions(id) {
  return await axios.get(`${apiUrl}/users/${id}/subscriptions/`, headers())
}

async function addUserSubscription(id, params) {
  return await axios.post(`${apiUrl}/users/${id}/subscriptions/`, params, headers())
}

async function cancelActiveSubscription(id) {
  return await axios.post(`${apiUrl}/users/${id}/subscriptions/cancel-active/`, {}, headers())
}

async function configuration(method='GET', params) {
  if(method === 'GET') {
    return await axios.get(`${apiUrl}/configuration/`, headers())
  }
  return await axios.post(`${apiUrl}/configuration/`, params, headers())
}

async function userList(params) {
  const query = new URLSearchParams({
    limit: params.limit,
    page: params.page,
    search: params.search || "",
  });
  if (params.status) query.append("status", params.status);
  if (params.subscription) query.append("subscription", params.subscription);
  if (params.subscriptionStatus) query.append("subscriptionStatus", params.subscriptionStatus);

  return await axios.get(`${apiUrl}/user_listing/?${query.toString()}`, headers())
}

async function getUserInfo(id) {
  return await axios.get(`${apiUrl}/users/${id}/`, headers())
}

async function deleteUser(id){
  return await axios.delete(`${apiUrl}/delete_user/?id=${id}`, headers())
}

async function listKnowledgeBase(params) {
  const query = new URLSearchParams({
    agent: params.agent_id,
    limit: params.limit,
    page: params.page,
  });
  if (params.search) query.append("search", params.search);
  if (params.status) query.append("status", params.status);

  return await axios.get(`${apiUrl}/list-knowledge-base/?${query.toString()}`, headers())
}

async function deleteKnowledgeBase(params) {
  return await axios.post(`${apiUrl}/clear-knowledge-base/`, params, headers())
}

async function addKnowledgeBase(params) {
  return await axios.post(`${apiUrl}/add-knowledge-base/`, params, headers())
}

async function createAgent(params) {
  return await axios.post(`${apiUrl}/agents/`, params, headers())
}

async function getAgents(params) {
  const query = new URLSearchParams({
    page: params.page,
    page_size: params.page_size,
  });

  if (params.user_id) {
    query.append("user_id", params.user_id);
  }

  if (params.all) {
    query.append("all", "true");
  }

  if (params.status) {
    query.append("status", params.status);
  } else if (params.deleted) {
    query.append("deleted", "true");
  }

  if (params.search) {
    query.append("search", params.search);
  }

  if (params.tone) {
    query.append("tone", params.tone);
  }

  if (params.assigned) {
    query.append("assigned", params.assigned);
  }

  return await axios.get(`${apiUrl}/agents/?${query.toString()}`, headers())
}

async function getAgent(id) {
  return await axios.get(`${apiUrl}/get-agent/?id=${id}`, headers())
}

async function changeAgentStatus(id, params) {
  return await axios.post(`${apiUrl}/change_agent_status/${id}/`, params, headers())
}

async function deleteAgent(id) {
  return await axios.post(`${apiUrl}/delete_agent/${id}/`, {}, headers())
}

async function restoreAgent(id) {
  return await axios.post(`${apiUrl}/restore_agent/${id}/`, {}, headers())
}

async function getAvailableNumbers() {
  return await axios.get(`${apiUrl}/phone-number-list/`, headers())
}

async function assignNumber(params) {
  return await axios.post(`${apiUrl}/phone-number-list/`, params, headers())
}

async function deleteNumber(id) {
  return await axios.delete(`${apiUrl}/phone-numbers/?id=${id}`, headers())
}

async function getTokenLimit(userId) {
  return await axios.get(`${apiUrl}/token-limit/${userId}/`, headers())
}

async function getUsageSummary(userId, days = 30) {
  return await axios.get(`${apiUrl}/usage/${userId}/?days=${days}`, headers())
}

async function updateTokenLimit(userId, params) {
  return await axios.post(`${apiUrl}/update-token-limit/${userId}/`, params, headers())
}











